import React, {Component} from 'react';

import * as Constant from '@app/Constant.js';

import axios from '@app/lib/axios';



import InfoCards from './InfoCards';
import ClassTable from './ClassTable';
import AppContentChart from './AppContentChart';
import AppContentScoreChart from './AppContentScoreChart';
import AppPie from './AppPie';


const getRandom = {

	"classList" : (num) => {
		var result = [];
		for(var i = 1; i <= num ; i++) {
			var age = i % 4;
			switch(age) {
				case 0 : age ="만3세"
					break;
				case 1 : age ="만4세"
					break;
				case 2 : age ="만5세"
					break;
				case 3 : age ="혼합"
					break;
			}

			var tmp = (i % 2);

			for(var x = 0; x <= tmp ; x++) {
				var obj = {
					id : i,
					age : age,
					app_num : i % 2 != 0 && x == 0 ? 2 : 1,
					app_name : x == 0? "토모노트" : "토모동화",
					app_score : Math.ceil(Math.random() * (100 - 30) + 30),
					content_score : Math.ceil(Math.random() * (100 - 30) + 30),
					version : x == 0? "3.1.3."+x : "2.1.4."+x,
					device : "deviceInfo  " + i
				};
				if(x == 0) obj.name = age + i + "반";
				result.push(obj);	
			}

		}

		return result;

	},
	"appContent" : (year) => {	
		var max_val = 400;
		var use_time_max_val = 120;

		var login = [];
		var use = [];
		var contents = [];
		var use_time = [];
		

		for(var i = 1 ; i <= 12 ; i++) {
			var login_val = Math.ceil(Math.random() * (200 - 80) + 80);
			if(max_val < login_val) max_val = login_val;
			login.push(login_val);

			var use_val = Math.ceil(Math.random() * (80 - 20) + 20);
			if(max_val < use_val) max_val = use_val;
			use.push(use_val);


			var contents_val = Math.ceil(Math.random() * (400 - 190) + 190);
			if(max_val < contents_val) max_val = contents_val;
			contents.push(contents_val);

			var use_time_val = Math.ceil(Math.random() * (120 - 30) + 30);
			if(use_time_max_val < use_time_val) use_time_max_val = use_time_val;
			use_time.push(use_time_val);
			
		}



		return {
			max_val : max_val,	
			use_time_max_val : use_time_max_val,

			login : login,
			use : use,
			contents : contents,
			use_time : use_time
		}


	},
	"appContentScore" : (year) => {

		var max_val = 0;

		var app = [];
		var contents = [];
		

		for(var i = 1 ; i <= 12 ; i++) {
			var app_val = Math.ceil(Math.random() * (100 - 30) + 30);
			if(max_val < app_val) max_val = app_val;
			app.push(app_val);

			var contents_val =  Math.ceil(Math.random() * (100 - 30) + 30);
			if(max_val < contents_val) max_val = contents_val;
			contents.push(contents_val);

		}

		return {
			max_val : max_val,
			app : app,
			contents : contents
		}
	}
};




export default class TasDashboard extends Component {

	constructor(props) {
		super(props);
		this.state = {
			year : 2020,
			totalClass : 17,
			yearClass : 7,
			createYear : 2017,
			nursery_name : "본사 유치원",
			branch_name : "본사관리 유엔젤",
			addr : "경기도 성남시 ",
			app_score : 170,
			content_score : 175,
			classList : getRandom.classList(7),
			appContent : getRandom.appContent(2020),
			appContentScore : getRandom.appContentScore(2020)
		};
	}



	render() {
		return (

			<div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                	<div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    	<div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                <div className="page-header">
                                    <h2 className="pageheader-title">{this.state.year + "년"} {this.state.nursery_name} ({this.state.branch_name})</h2>
                                    <div className="page-breadcrumb ml-2">
                                        {this.state.addr} / {this.state.year} ~ 
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" style={{textAlign: "right"}}>
                            </div>
                           
                        </div>


                    	<div className="row">
                            <InfoCards data={{totalClass : this.state.totalClass, createYear : this.state.createYear, yearClass : this.state.yearClass, app_score : this.state.app_score, content_score : this.state.content_score}}/>
                    	</div>
                    	<div className="row">
                        	<div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                                <ClassTable year={this.state.year} classList={this.state.classList} height={300} />
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                                <AppPie data={this.state.classList} height={300} />
                            </div>
                       	</div>
                        <div className="row">
                            <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12">
                                <AppContentChart chartData={this.state.appContent}/>
                            </div>
                            <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12">
                                <AppContentScoreChart chartData={this.state.appContentScore}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

		)
	}




}